<template>
  <div id="horseList">
    <div v-if="horses.length">
      <div class="horse-list-wrapper">
        <HorseCard
            v-for="(horse) in horses"
            :key="horse.id"
            :horse="horse"
        />

        <div class="load-more-trigger" v-observe-visibility="loadMore"></div>
      </div>
    </div>
    <div v-else class="no-horses">No Animals Matched Your Search Criteria</div>
  </div>
</template>

<script>
import HorseCard from '@/components/HorseCard.vue'

export default {
  name: 'SearchResults',
  components: {
    HorseCard
  },
  props: {
    horses: Array
  },
  emits: ['loadMore'],
  methods: {
    loadMore: function (isVisible) {
      if (isVisible) {
        this.$emit('loadMore')
      }
    }
  }
}
</script>
